var render = function render(){var _vm=this,_c=_vm._self._c;return _c('lDfault',{attrs:{"title":"教材退货"}},[_vm._v(" 教材退货 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }